import React from 'react';
import { LoginForm } from '../../auth/components/LoginForm';
import Dialog from '../../common/components/Dialog';
import { useTranslations } from '../../localization/useTranslations';

interface LoginModalLockProps {
  isOpen: boolean;
}

const LoginModalLock: React.FC<LoginModalLockProps> = ({ isOpen }) => {
  const translations = useTranslations();

  return (
    <Dialog isOpen={isOpen}>
      <div className="modal modal--small login-modal">
        <div className="modal__wrapper">
          <div className="modal__header login-modal__header">
            <h5>{translations.printContentLockModal?.loginRegister || 'Login / Register'}</h5>
          </div>

          <div className="login-modal__content modal__content">
            <div className="login-modal__section-divider" />

            <div className="login-modal__description basic-16">
              {translations.printContentLockModal?.modalMessage ||
                'To view articles from the Forbes print magazine, you must have an account with an active business subscription.'}
            </div>

            <LoginForm isFormInModal />
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default LoginModalLock;
